import {Injectable} from '@angular/core';
import {RRule, datetime, rrulestr} from 'rrule';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class RruleService {
  createAutoSkedRRule(byweekday: number[], dtstart: moment.Moment, tzid: string) {
    const rrule = new RRule({
      freq: RRule.WEEKLY,
      interval: 1,
      byweekday,
      dtstart: datetime(
        dtstart.year(),
        // This will create the start date a month before, the current month would be dtstart.month() + 1
        dtstart.month(),
        dtstart.date(),
        dtstart.hour(),
        dtstart.minute(),
        dtstart.second()
      ),
      tzid,
    });

    return rrule.toString();
  }

  parseTimezoneFromRRule(rruleString: string): string | null {
    try {
      // Use rrule's built-in parser
      const rule = rrulestr(rruleString);

      // The parsed rule will have the tzid property if it was specified
      return rule.options?.tzid || null;
    } catch (error) {
      console.warn('Failed to parse rrule:', error);
      return null;
    }
  }

  updateRRuleTimezone(rruleString: string, newTimezone: string): string {
    try {
      // Use regex to replace only the TZID value in the DTSTART line
      // This preserves all other parts of the rrule string exactly as they are
      // Pattern matches: DTSTART;TZID=<old_timezone>:
      const tzidPattern = /(DTSTART;TZID=)([^:]+)(:)/;

      if (tzidPattern.test(rruleString)) {
        // Replace only the timezone identifier, keeping everything else intact
        return rruleString.replace(tzidPattern, `$1${newTimezone}$3`);
      } else {
        console.warn('No TZID found in rrule string, returning original');
        return rruleString;
      }
    } catch (error) {
      console.error('Failed to update rrule timezone:', error);
      return rruleString; // Return original if anything fails
    }
  }
}
